module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table>\r\n';
 for (i in data) {
    d = data[i];
    
__p+='\r\n    <tr class="location">\r\n\t    <td class="type">\r\n\t        '+
((__t=( d.value ))==null?'':__t)+
'\r\n\t    </td>\r\n\t    <td class="title">\r\n\t        '+
((__t=( d.full_address ))==null?'':__t)+
'\r\n\t    </td>\r\n    </tr>\r\n';
 } 
__p+='\r\n</table>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/views/map/tooltip/tooltip.tmpl
 ** module id = 58
 ** module chunks = 0
 **/